import { Component, OnInit } from '@angular/core';
import { LoginDataService } from '../services/dhukan/login-data.service';
import { NavigationExtras, Router } from '@angular/router';
import { OpenshiftComponent } from '../components/openshift/openshift.component';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-navigation',
  templateUrl: './navigation.component.html',
  styleUrls: ['./navigation.component.css']
})
export class NavigationComponent implements OnInit {

  userBO: any = {};
  userrolerightsColl: any = [];
  userView: any = {};

  isgroup: boolean = false;
  issubgroup: boolean = false;
  ismodifier: boolean = false;
  ismodifiertype: boolean = false;
  istax: boolean = false;
  iscourse: boolean = false;
  isdepartment: boolean = false;
  isfoodsymbol: boolean = false;
  isdinetype: boolean = false;
  iscustomer: boolean = false;
  istable: boolean = false;
  istablesection: boolean = false;
  isproduct: boolean = false;
  isbrand: boolean = false;
  issize: boolean = false;
  iscuisine: boolean = false;
  isuom: boolean = false;
  ispaymentmode: boolean = false;
  iscardtype: boolean = false;
  iscurrency: boolean = false;
  iscompany: boolean = false;
  issupplier: boolean = false;
  isbranch: boolean = false;
  islocality: boolean = false;
  isquestion: boolean = false;
  isfeedback: boolean = false;
  isordermode: boolean = false;
  isshift: boolean = false;
  isreason: boolean = false;
  isstation: boolean = false;
  isuser: boolean = false;
  isuserrole: boolean = false;
  ischarges: boolean = false;
  issales: boolean = false;
  isopenshift: boolean = false;
  issettings: boolean = false;
  isreport: boolean = false;
  ispurchase: boolean = false;
  ispurchaseaccounts: boolean = false;
  isadj: boolean = false;
  isphysicalstock: boolean = false;
  isadjtype: boolean = false;
  isexpense: boolean = false;
  isincome: boolean = false;
  isexpensetype: boolean = false;
  isincometype: boolean = false;
  ispricetype: boolean = false;
  iskitchennotes: boolean = false;
  isitemcategory: boolean = false;
  israwmaterial: boolean = false;
  ispurchasereturn: boolean = false;
  isaccounttype: boolean = false;
  isaccount: boolean = false;
  issubledgertype: boolean = false;
  issubledger: boolean = false;
  iscostcenter: boolean = false;
  isjv: boolean = false;
  ispayment: boolean = false;
  islpo: boolean = false;
  istransfer: boolean = false;

  istablemenu: boolean = true;
  isinventorymenu: boolean = true;
  iscrmmenu: boolean = true;
  isconfigrationmenu: boolean = true;

  isenableaccounts: boolean = true;
  isenableinventory: boolean = true;

  constructor(private loginService: LoginDataService, public router: Router, private productFindService: NgbModal) {
    this.fnServiceChanges();
  }

  fnServiceChanges() {
    this.userrolerightsColl = this.loginService.userrolerightsColl;
    this.loginService.serviceloginChange.subscribe((value) => {
      this.userView = value
      if (this.userView.userBO) {
        this.userBO = this.userView.userBO

        this.isenableinventory=this.userBO.isinventory
        this.isenableaccounts=this.userBO.isaccounts 
      }

      this.fnCheckMenu();

    });
  }

  ngOnInit() {
    this.loginService.fnGetUserRoleList();

  }


  fnCheckMenu() {

    if (this.loginService.fnCheckUserRoleAll('Group')) {
      this.isgroup = true;
    }
    if (this.loginService.fnCheckUserRoleAll('Subgroup')) {
      this.issubgroup = true;
    }
    if (this.loginService.fnCheckUserRoleAll('Modifier')) {
      this.ismodifier = true;
    }
    if (this.loginService.fnCheckUserRoleAll('Modifiertype')) {
      this.ismodifiertype = true;
    }
    if (this.loginService.fnCheckUserRoleAll('Tax')) {
      this.istax = true;
    }
    if (this.loginService.fnCheckUserRoleAll('Course')) {
      this.iscourse = true;
    }
    if (this.loginService.fnCheckUserRoleAll('Department')) {
      this.isdepartment = true;
    }
    if (this.loginService.fnCheckUserRoleAll('Foodsymbol')) {
      this.isfoodsymbol = true;
    }
    if (this.loginService.fnCheckUserRoleAll('Dinetype')) {
      this.isdinetype = true;
    }
    if (this.loginService.fnCheckUserRoleAll('Customer')) {
      this.iscustomer = true;
    }
    if (this.loginService.fnCheckUserRoleAll('Table')) {
      this.istable = true;
    }
    if (this.loginService.fnCheckUserRoleAll('TableSection')) {
      this.istablesection = true;
    }
    if (this.loginService.fnCheckUserRoleAll('Product')) {
      this.isproduct = true;
    }
    if (this.loginService.fnCheckUserRoleAll('Brand')) {
      this.isbrand = true;
    }
    if (this.loginService.fnCheckUserRoleAll('Size')) {
      this.issize = true;
    }
    if (this.loginService.fnCheckUserRoleAll('Cuisine')) {
      this.iscuisine = true;
    }
    if (this.loginService.fnCheckUserRoleAll('Uom')) {
      this.isuom = true;
    }
    if (this.loginService.fnCheckUserRoleAll('Paymentmode')) {
      this.ispaymentmode = true;
    }
    if (this.loginService.fnCheckUserRoleAll('Cardtype')) {
      this.iscardtype = true;
    }
    if (this.loginService.fnCheckUserRoleAll('Currency')) {
      this.iscurrency = true;
    }
    if (this.loginService.fnCheckUserRoleAll('Company')) {
      this.iscompany = true;
    }
    if (this.loginService.fnCheckUserRoleAll('Supplier')) {
      this.issupplier = true;
    }
    if (this.loginService.fnCheckUserRoleAll('Branch')) {
      this.isbranch = true;
    }
    if (this.loginService.fnCheckUserRoleAll('Locality')) {
      this.islocality = true;
    }
    if (this.loginService.fnCheckUserRoleAll('Question')) {
      this.isquestion = true;
    }
    if (this.loginService.fnCheckUserRoleAll('Feedback')) {
      this.isfeedback = true;
    }


    if (this.loginService.fnCheckUserRoleAll('Ordermode')) {
      this.isordermode = true;
    }
    if (this.loginService.fnCheckUserRoleAll('Shift')) {
      this.isshift = true;
    }
    if (this.loginService.fnCheckUserRoleAll('Reason')) {
      this.isreason = true;
    }
    if (this.loginService.fnCheckUserRoleAll('Station')) {
      this.isstation = true;
    }
    if (this.loginService.fnCheckUserRoleAll('User')) {
      this.isuser = true;
    }
    if (this.loginService.fnCheckUserRoleAll('Userrole')) {
      this.isuserrole = true;
    }
    if (this.loginService.fnCheckUserRoleAll('Charges')) {
      this.ischarges = true;
    }
    if (this.loginService.fnCheckUserRoleAll('Settings')) {
      this.issettings = true;
    }
    if (this.loginService.fnCheckUserRoleAll('Report')) {
      this.isreport = true;
    }
    if (this.loginService.fnCheckUserRoleAll('Sales')) {
      this.issales = true;
    }
    if (this.loginService.fnCheckUserRoleAll('OpenShift')) {
      this.isopenshift = true;
    }
    if (this.loginService.fnCheckUserRoleAll('Purchase')) {
      this.ispurchase = true;
    }
    if (this.loginService.fnCheckUserRoleAll('Purchase')) {
      this.ispurchaseaccounts = true;
    }
    if (this.loginService.fnCheckUserRoleAll('Adj')) {
      this.isadj = true;
    }
    if (this.loginService.fnCheckUserRoleAll('Physicalstock')) {
      this.isphysicalstock = true;
    }
    if (this.loginService.fnCheckUserRoleAll('Adjtype')) {
      this.isadjtype = true;
    }
    if (this.loginService.fnCheckUserRoleAll('Income')) {
      this.isincome = true;
    }
    if (this.loginService.fnCheckUserRoleAll('Expense')) {
      this.isexpense = true;
    }
    if (this.loginService.fnCheckUserRoleAll('Incometype')) {
      this.isincometype = true;
    }
    if (this.loginService.fnCheckUserRoleAll('Expensetype')) {
      this.isexpensetype = true;
    }
    if (this.loginService.fnCheckUserRoleAll('Pricetype')) {
      this.ispricetype = true;
    }
    if (this.loginService.fnCheckUserRoleAll('Kitchennotes')) {
      this.iskitchennotes = true;
    }
    if (this.loginService.fnCheckUserRoleAll('Itemcategory')) {
      this.isitemcategory = true;
    }
    if (this.loginService.fnCheckUserRoleAll('Rawmaterial')) {
      this.israwmaterial = true;
    }
    if (this.loginService.fnCheckUserRoleAll('PurchaseReturn')) {
      this.ispurchasereturn = true;
    }
    if (this.loginService.fnCheckUserRoleAll('Ledger')) {
      this.isaccount = true;
    }
    if (this.loginService.fnCheckUserRoleAll('LedgerType')) {
      this.isaccounttype = true;
    }
    if (this.loginService.fnCheckUserRoleAll('Subledger')) {
      this.issubledger = true;
    }
    if (this.loginService.fnCheckUserRoleAll('SubledgerType')) {
      this.issubledgertype = true;
    }
    if (this.loginService.fnCheckUserRoleAll('CostCenter')) {
      this.iscostcenter = true;
    }
    if (this.loginService.fnCheckUserRoleAll('JournalVoucher')) {
      this.isjv = true;
    }
    if (this.loginService.fnCheckUserRoleAll('Payment')) {
      this.ispayment = true;
    }
    if (this.loginService.fnCheckUserRoleAll('Lpo')) {
      this.islpo = true;
    }
    if (this.loginService.fnCheckUserRoleAll('Transfer')) {
      this.istransfer = true;
    }

    //All Outlet Check Menu

    if (this.loginService.fnGetCompanyId() === 0) {

      this.istablesection = false
      this.istable = false
      this.istablemenu = false


      this.isproduct = false
      this.ismodifier = false
      this.ispricetype = false
      this.ischarges = false
      this.isordermode = false


      this.israwmaterial = false
      this.issupplier = false

      this.isinventorymenu = false


      this.isexpense = false
      this.isincome = false

      this.iscrmmenu = false

      this.isconfigrationmenu=false

    }







  }


  fnPartyMenuClick(type) {
    try {
      let navigationExtras: NavigationExtras = {
        queryParams: {
          'ptype': type,
        }
      }

      this.router.navigate(['/Party'], navigationExtras);

      this.loginService.isshowmenu = !this.loginService.isshowmenu
      if (this.loginService.isnavmobile) {
        this.fnMenuMobileClick()
      }
    } catch (ex) {

    }
  }
  fnPurchaseMenuClick(type) {
    try {
      // let navigationExtras: NavigationExtras = {
      //   queryParams: {
      //     'purchasetype': type,
      //   }
      // }

      this.router.navigate(['/Purchase']);

      this.loginService.isshowmenu = !this.loginService.isshowmenu
      if (this.loginService.isnavmobile) {
        this.fnMenuMobileClick()
      }
    } catch (ex) {

    }
  }
  fnReportMenuClick(type) {
    try {
      let navigationExtras: NavigationExtras = {
        queryParams: {
          'type': type,
        }
      }

      this.router.navigate(['/Report'], navigationExtras);
      this.loginService.isshowmenu = !this.loginService.isshowmenu
      if (this.loginService.isnavmobile) {
        this.fnMenuMobileClick()
      }
    } catch (ex) {

    }
  }

  fnAllMenuClick(formname) {
    this.router.navigate([formname]);

    this.loginService.isshowmenu = !this.loginService.isshowmenu
    if (this.loginService.isnavmobile) {
      this.fnMenuMobileClick()
    }

  }



  fnMenuMobileClick() {
    this.loginService.isnavmobile = !this.loginService.isnavmobile

    if (this.loginService.isnavmobile) {
      var dv = document.getElementById("divnavbar")
      dv.classList.remove("left-sidebar")
      dv.classList.add("left-sidebarmob")


      var dv = document.getElementById("dvdrop")
      dv.classList.remove("backdrop")
    }
    else {
      var dv = document.getElementById("divnavbar")
      dv.classList.remove("left-sidebarmob")
      dv.classList.add("left-sidebar")

      var dv = document.getElementById("dvdrop")
      dv.classList.remove("backdrop")
    }

  }

  fnNavigationFixClick() {
    this.loginService.isnavfix = !this.loginService.isnavfix

    if (this.loginService.isnavfix) {
      var dv = document.getElementById("dvnavcontainer")
      dv.classList.add("lock-nav")


    }
    else {
      var dv = document.getElementById("dvnavcontainer")
      dv.classList.remove("lock-nav")


    }

  }







  // fnAddOpenShift() {
  //   try {


  //     const modalRef = this.productFindService.open(OpenshiftComponent, { size: <any>'l', backdrop: 'static' });
  //     modalRef.componentInstance.ngOnInit();

  //     modalRef.componentInstance.emitData.subscribe((receivedEntry) => {



  //     });


  //   } catch (ex) {

  //   }
  // }

  fnEditCompany() {
    try {
      let navigationExtras: NavigationExtras = {
        queryParams: {
          'id': this.loginService.fnGetCompanyId(),
        }
      }

      this.router.navigate(['/AddCompany'], navigationExtras);
    } catch (ex) {
      // this.fnShowErrorMsg(ex);
    }
  }

  
  fnLogout() {
    localStorage.removeItem("bstoken");
    localStorage.removeItem("bstokenon");
    this.router.navigate(['/Login']);
  }

  
}
